import {
  EditCreatorProductData_TPL,
  MODE,
} from '@services/MarppleShopStudio/widget/CreatorProduct/core/types/types.ts';
import klass from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/Form.module.scss';
import { ChangeModeEvent } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/events.ts';
import { AllProductTypes } from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/types.ts';
import {
  BaseForm,
  FormSectionCreator,
} from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/BaseForm.ts';
import { ButtonAction } from '@services/MarppleShop/shared/components/atoms/ButtonAction/ButtonAction.ts';
import { MainInfoSection } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/section-views/MainInfoSection.ts';
import { SalesInfoSection } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/section-views/SalesInfoSection.ts';
import { StockAndOptionSection } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/section-views/StockAndOptionSection.ts';
import { DetailInfoSection } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/section-views/DetailInfoSection.ts';
import { DeliveryAndRefundInfoSection } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/section-views/DeliveryAndRefundInfoSection.ts';
import { isApp } from '@services/MarppleShop/shared/app/util.ts';

export class EditForm_TPL extends BaseForm<EditCreatorProductData_TPL> {
  protected override createSections(): FormSectionCreator[] {
    return [
      (store, data) =>
        new MainInfoSection({
          store,
          products_memberships: data.products_memberships ?? [],
          mpsCategories: data.mpsCategories,
          goods_type_id: data.goods_type_id,
          is_created_sku: data.is_created_sku,
          is_plus: data.is_plus,
          is_public: data.stores_product?._.product.is_public,
          is_studio_worker_admin: data.is_studio_worker_admin,
          is_crew_admin: data.action?.is_crew_admin,
        }),
      (store, data) => new SalesInfoSection({ store, is_created_sku: data.is_created_sku }),
      (store, data) =>
        new StockAndOptionSection({
          store,
          is_created_sku: data.is_created_sku,
          is_studio_worker_admin: data.is_studio_worker_admin,
          is_mobile: data.is_mobile,
        }),
      (store, data) => new DetailInfoSection({ store, is_created_sku: data.is_created_sku }),
      (store, data) =>
        new DeliveryAndRefundInfoSection({
          store,
          stores_delivery_companies: data.stores_delivery_companies,
          goods_type_id: data.goods_type_id,
          is_created_sku: data.is_created_sku,
        }),
    ];
  }

  protected override createButtons(): {
    header: ButtonAction[];
    footer: ButtonAction[];
    seeMore?: boolean;
  } {
    return {
      header: [
        isApp()
          ? new ButtonAction({
              klass: klass.button_close,
              size: this.data.is_mobile ? 'large' : 'small',
              label: '취소',
              type: 'line',
            })
          : new ButtonAction({
              klass: klass.button_preview,
              size: this.data.is_mobile ? 'large' : 'small',
              label: '미리보기',
              type: 'line',
            }),
        new ButtonAction({
          klass: klass.button_save,
          size: this.data.is_mobile ? 'large' : 'small',
          label: '저장하기',
          type: 'blue',
        }),
      ],

      footer: [
        new ButtonAction({
          klass: klass.button_preview,
          size: this.data.is_mobile ? 'large' : 'small',
          label: '미리보기',
          type: 'line',
        }),
        new ButtonAction({
          klass: klass.button_save,
          size: this.data.is_mobile ? 'large' : 'small',
          label: '저장하기',
          type: 'blue',
        }),
      ],

      seeMore: this.data.action.is_crew_admin,
    };
  }

  override onRender() {
    super.onRender();

    this.store.subscribeState(
      (state) => state.formData._.product._.base_product.is_use_creator_en,
      (is_intl) => {
        this.dispatchEvent(ChangeModeEvent, {
          bubbles: true,
          detail: {
            mode: is_intl ? MODE.EDIT_TPL_INTL : MODE.EDIT_TPL,
            data: {
              ...this.data,
              thumbnails: this.thumbnailFormView.getFileList(),
              stores_product: this.store.formData as AllProductTypes,
            },
          },
        });
      },
    );
  }
}
